// extracted by mini-css-extract-plugin
export default {"container":"H1akJ8yTLJCt75SV8_3g","icon":"qknda6Njhd6kyuzPa3tu","whatsText":"J9bwvXES06z7Paud2GKv"};